import './VideoWithTextBlock.scss';
import { createApp } from 'vue';
import VideoWithTextBlockVue from './VideoWithTextBlock.vue';

function mountingVideoWithTextBlocks() {
	const videoWithTextBlocks = document.querySelectorAll('[data-video-with-text]');
	
	if (videoWithTextBlocks.length > 0) {
		videoWithTextBlocks.forEach((block) => {
			const app = createApp({
				name: 'VideoWithTextApp',
			});
			app.component('video-with-text-block', VideoWithTextBlockVue);
			app.mount(block);
		});
	}
}

mountingVideoWithTextBlocks();